import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useState } from "react";
import { keyBy } from "lodash";
import { getSolutionListApi } from '../../../api';
import useFetchData from '../../common/hooks/useFetch';
export var keyUserTypeSubscriptions = null;
export var getKeyUserTypeSubscriptions = function getKeyUserTypeSubscriptions() {
  return keyUserTypeSubscriptions;
};
export var resetKeyUserTypeSubscriptions = function resetKeyUserTypeSubscriptions() {
  keyUserTypeSubscriptions = null;
};
export var resetKeyUserTypeSubscriptionsSelectedStatus = function resetKeyUserTypeSubscriptionsSelectedStatus() {
  if (keyUserTypeSubscriptions) {
    for (var key in keyUserTypeSubscriptions) {
      keyUserTypeSubscriptions[key].selected = false;
    }
  }
};
export var setOneKeyUserTypeSubscriptionSelectedStatus = function setOneKeyUserTypeSubscriptionSelectedStatus(subscriptionId, selected) {
  if (keyUserTypeSubscriptions[subscriptionId]) {
    keyUserTypeSubscriptions[subscriptionId].selected = selected;
  }
};
export var setKeyUserTypeSubscriptionsSelectedStatus = function setKeyUserTypeSubscriptionsSelectedStatus(selectedUserTypeSubscriptions) {
  for (var key in keyUserTypeSubscriptions) {
    if (selectedUserTypeSubscriptions.indexOf(key) > -1) {
      keyUserTypeSubscriptions[key].selected = true;
    } else {
      keyUserTypeSubscriptions[key].selected = false;
    }
  }
};
export var setUserTypeSubscriptionsStatus = function setUserTypeSubscriptionsStatus(selectedUserTypeSubscriptionIds, isSelected) {
  selectedUserTypeSubscriptionIds.forEach(function (id) {
    var _keyUserTypeSubscript;

    if ((_keyUserTypeSubscript = keyUserTypeSubscriptions) !== null && _keyUserTypeSubscript !== void 0 && _keyUserTypeSubscript[id]) {
      keyUserTypeSubscriptions[id].selected = isSelected;
    }
  });
};
export var useSolutions = function useSolutions() {
  var _useFetchData = useFetchData(getSolutionListApi, {
    useAutoCache: true,
    key: 'solutionList',
    cacheTime: 0
  }),
      _useFetchData$data = _useFetchData.data,
      solutionList = _useFetchData$data === void 0 ? [] : _useFetchData$data,
      solutionListLoading = _useFetchData.isLoading,
      refetch = _useFetchData.refetch;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      formattedSolutions = _useState2[0],
      setFormattedSolutions = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      keySolutions = _useState4[0],
      setKeySolutions = _useState4[1];

  var formatSolutions = useCallback(function () {
    var formattedSolutions = (solutionList || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        isDisabled: false
      });
    });
    setFormattedSolutions(formattedSolutions);
  }, [solutionList]);
  useEffect(function () {
    if (solutionList && solutionList.length) {
      formatSolutions();
      var data = keyBy(solutionList, 'id');
      var subscriptions = {};
      solutionList.forEach(function (element) {
        data[element.id]['keyRoles'] = keyBy(element.roles, 'id');
        element.roles.forEach(function (item) {
          if (item.userSubscriptions) {
            subscriptions = _objectSpread(_objectSpread({}, subscriptions), keyBy(item.userSubscriptions, 'objectID'));
          }
        });
      });
      keyUserTypeSubscriptions = subscriptions;
      setKeySolutions(data);
    }
  }, [formatSolutions, solutionList]);
  var filterDisableSolution = useCallback(function (selectedSolutions) {
    setFormattedSolutions(function (prevFormattedSolutions) {
      if (!(prevFormattedSolutions !== null && prevFormattedSolutions !== void 0 && prevFormattedSolutions.length)) {
        return prevFormattedSolutions;
      }

      return prevFormattedSolutions.map(function (i) {
        return selectedSolutions.find(function (n) {
          return i.id === n.id;
        }) ? _objectSpread(_objectSpread({}, i), {}, {
          isDisabled: true
        }) : _objectSpread(_objectSpread({}, i), {}, {
          isDisabled: false
        });
      });
    });
  }, []);
  return {
    formattedSolutions: formattedSolutions,
    keySolutions: keySolutions,
    solutionListLoading: solutionListLoading,
    filterDisableSolution: filterDisableSolution,
    refetchSolution: refetch
  };
};
export default useSolutions;